import { DISALLOWED_TAGS } from './constant';

function escapeHtml(string) {
  const entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;',
  };
  return String(string).replace(/[&<>"'`=\/]/g, (s) => entityMap[s]);
}

export default function allowedTags(value, allowedTagsValue = [], disallowedTagsValue = [], encodeHtmlEntities = false) {
  if (!value || typeof value !== 'string') {
    return value;
  }

  const disallowedTags = disallowedTagsValue.concat(DISALLOWED_TAGS);
  let previousValue;
  do {
    previousValue = value;
    // eslint-disable-next-line no-param-reassign
    value = value.replace(/(<([\w]+)\s?[\w\d=*.'"_@/\\]*>)|(<\/\w+>)/gi, (match, openTag, openTagTitle, closeTag, closeTagTitle) => {
      const result = openTagTitle || closeTagTitle;
      const disallow = disallowedTags.filter((tag) => !allowedTagsValue.includes(tag));

      if (!result) {
        return match;
      }

      if (disallow.includes(result)) {
        return encodeHtmlEntities ? escapeHtml(match) : '';
      }
      return match;
    });
  } while (previousValue !== value);

  return value;
}
